import { ComponentPropsWithoutRef, useState } from "react";
import ModalLayout from "components/modal/modal-layout/ModalLayout";
import ConfirmModal from "components/confirm-modal";
import RadioButton from "components/radio-button";

import deleteAppointmentSeries from "services/scheduler/deleteAppointmentSeries";
import cancelAppointment from "services/scheduler/cancelAppointment";
import styles from "./ConfirmCancelSeriesModal.module.scss";

const CANCEL_OPTIONS = [
  { label: "Only this session", value: "this_session" },
  {
    label: "This and all future sessions",
    value: "this_and_future_session",
  },
];

type Props = {
  appointment: AppointmentWithSeriesInfo;
  onCancelled: (() => void) | null;
} & Pick<ComponentPropsWithoutRef<typeof ModalLayout>, "show" | "onHide">;

const ConfirmCancelSeriesModal = ({
  appointment,
  show,
  onHide,
  onCancelled,
}: Props) => {
  const [cancelOption, setCancelOption] = useState("this_session");

  const [error, setError] = useState<any>();
  const [busy, setBusy] = useState(false);

  const handleHide = () => {
    setError(undefined);
    setBusy(false);
    setCancelOption("this_session");
    onHide();
  };

  const onCancelOptionChange = (event) => {
    const inputField = event.currentTarget;
    setCancelOption(inputField.value);
  };

  const deleteSeries = async () => {
    setBusy(true);
    try {
      if (cancelOption === "this_session") {
        await cancelAppointment(appointment.appointment_id);
      } else if (cancelOption === "this_and_future_session") {
        await deleteAppointmentSeries(
          appointment.appointment_series_id,
          appointment.appointment_id,
        );
      }
      if (onCancelled) {
        onCancelled();
      }
      handleHide();
    } catch (error) {
      setError(error);
    } finally {
      setBusy(false);
    }
  };

  return (
    <ConfirmModal
      labelTitle={"Cancel Recurring Sessions?"}
      children={
        <div>
          <p>
            Would you like to cancel only this session, OR this and all future
            sessions in the series?
          </p>
          {CANCEL_OPTIONS.map((option) => (
            <RadioButton
              key={option.value}
              className={styles["confirm-cancel-series__radio"]}
              id={option.value}
              label={option.label}
              value={option.value}
              name="cancel-option"
              onChange={onCancelOptionChange}
              checked={cancelOption === option.value}
            />
          ))}
        </div>
      }
      labelConfirm={"Confirm"}
      hideCancel={true}
      show={show}
      onCancel={() => {
        handleHide();
      }}
      onConfirm={() => deleteSeries()}
      disabled={busy}
      error={error}
    />
  );
};

export default ConfirmCancelSeriesModal;
